import { render, staticRenderFns } from "./ChangeClientLanguage.vue?vue&type=template&id=5beb2846&scoped=true"
import script from "./ChangeClientLanguage.vue?vue&type=script&lang=js"
export * from "./ChangeClientLanguage.vue?vue&type=script&lang=js"
import style0 from "./ChangeClientLanguage.vue?vue&type=style&index=0&id=5beb2846&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb2846",
  null
  
)

export default component.exports